import CommentSection from './commentSection';

export default CommentSection;